window.i18n_rtl_class = function() {
  if (['he', 'ar'].indexOf(I18n.locale) != -1) return 'grid--rev';
  else return '';
};
